{
  "familyId": "SPR-KLANK-JAGER",
  "questions": [
    {
      "id": "SPR-KLANK-JAGER-001",
      "familyId": "SPR-KLANK-JAGER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_open_lange",
      "questionType": "multiple_choice",
      "question": "Verdeel het woord 'jager' in lettergrepen. Welke verdeling is juist?",
      "options": ["ja-ger", "jag-er", "ja-gerr", "jaa-ger"],
      "correctAnswer": 0,
      "stimulusAids": [
        { "type": "syllableBlocks", "data": { "word": "jager", "syllables": ["ja", "ger"], "types": ["open", "closed"], "label": "Lettergreepverdeling: ja-ger" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Jager-regel (open lettergreep)", "content": "Bij 'jager' eindigt de eerste lettergreep op een klinker: ja-ger. De 'a' klinkt lang omdat de lettergreep open is (eindigt op een klinker). Je schrijft maar één 'a'.", "icon": "lightbulb" } }
      ],
      "conceptId": "open_syllable_jager",
      "variantIndex": 1,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Jager' verdeel je als ja-ger. De eerste lettergreep 'ja' eindigt op een klinker — dat is een open lettergreep. In een open lettergreep klinkt de klinker lang, en schrijf je maar één letter.",
        "solutionSteps": [
          "Verdeel in lettergrepen: ja-ger",
          "De eerste lettergreep 'ja' eindigt op een klinker → open lettergreep",
          "Open lettergreep → lange klank → één klinker schrijven"
        ],
        "distractorExplanations": {
          "0": "Goed! 'ja-ger' — de eerste lettergreep is open (eindigt op een klinker), dus de 'a' klinkt lang.",
          "1": "Je dacht waarschijnlijk dat de 'g' bij de eerste lettergreep hoort. Maar dan wordt het 'jag-er' en klinkt de 'a' kort (zoals in 'jacht'). Bij 'jager' klinkt de 'a' lang → ja-ger. Onthoud: open lettergreep = lange klank.",
          "2": "Je dacht waarschijnlijk dat je twee r's schrijft. Maar 'jager' heeft maar één 'r'. De dubbele medeklinker hoort bij de bakker-regel (korte klinker), niet bij de jager-regel (lange klinker). Onthoud: lange klank = enkele medeklinker.",
          "3": "Je dacht waarschijnlijk dat je twee a's schrijft. Maar in een open lettergreep (ja-ger) schrijf je maar één 'a' — de klank is al lang door de open lettergreep. Onthoud: open lettergreep = één klinker."
        }
      }
    },
    {
      "id": "SPR-KLANK-JAGER-002",
      "familyId": "SPR-KLANK-JAGER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_open_lange",
      "questionType": "multiple_choice",
      "question": "Welke spelling van het werkwoord is juist?",
      "options": ["loppen", "loopen", "lopen", "lopn"],
      "correctAnswer": 2,
      "stimulusAids": [
        { "type": "syllableBlocks", "data": { "word": "lopen", "syllables": ["lo", "pen"], "types": ["open", "closed"], "label": "Lettergreepverdeling: lo-pen" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Jager-regel: lopen", "content": "Verdeel: lo-pen. De eerste lettergreep 'lo' is open (eindigt op een klinker). De 'o' klinkt lang → schrijf één 'o' en één 'p'.", "icon": "lightbulb" } }
      ],
      "conceptId": "open_syllable_lopen",
      "variantIndex": 2,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "'Lopen' verdeel je als lo-pen. De eerste lettergreep 'lo' is open — de 'o' klinkt lang. Bij een open lettergreep schrijf je maar één klinker en één medeklinker.",
        "solutionSteps": [
          "Verdeel in lettergrepen: lo-pen",
          "'lo' eindigt op een klinker → open lettergreep",
          "Lange klank → één 'o' en één 'p'"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je twee p's schrijft. Maar 'loppen' zou een korte 'o' geven (zoals in 'hoppen'). Bij 'lopen' klinkt de 'o' lang → één 'p'. Onthoud: lange klank = enkele medeklinker (jager-regel).",
          "1": "Je dacht waarschijnlijk dat je twee o's schrijft. Maar in een open lettergreep (lo-pen) is de klank al lang — je hoeft geen extra 'o' toe te voegen. Onthoud: open lettergreep = één klinker.",
          "2": "Goed! 'lopen' — open lettergreep, dus één 'o' en één 'p'.",
          "3": "Je dacht waarschijnlijk dat je de 'e' weglaat. Maar 'lopn' is geen bestaand woord. Het is 'lo-pen' met twee lettergrepen. Onthoud: elk woord heeft minstens één klinker per lettergreep."
        }
      }
    },
    {
      "id": "SPR-KLANK-JAGER-003",
      "familyId": "SPR-KLANK-JAGER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_open_lange",
      "questionType": "multiple_choice",
      "question": "Het woord 'boten' (meervoud van boot). Welke lettergreepverdeling hoort erbij?",
      "options": ["bot-en", "bo-ten", "boo-ten", "bo-tten"],
      "correctAnswer": 1,
      "stimulusAids": [
        { "type": "syllableBlocks", "data": { "word": "boten", "syllables": ["bo", "ten"], "types": ["open", "closed"], "label": "Lettergreepverdeling: bo-ten" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Jager-regel: boten", "content": "Verdeel: bo-ten. De eerste lettergreep 'bo' is open. De 'o' klinkt lang → schrijf één 'o'. Vergelijk met 'botten' (korte 'o', dubbele 't' — bakker-regel).", "icon": "lightbulb" } }
      ],
      "conceptId": "open_syllable_boten",
      "variantIndex": 3,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Boten' verdeel je als bo-ten. De eerste lettergreep 'bo' is open — de 'o' klinkt lang. Vergelijk: 'botten' (korte 'o', dubbele 't') is de bakker-regel.",
        "solutionSteps": [
          "Luister: klinkt de 'o' lang of kort?",
          "Lang → open lettergreep → bo-ten",
          "Kort zou zijn: bot-ten (bakker-regel)"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat de 't' bij de eerste lettergreep hoort. Maar dan wordt het 'bot-en' en klinkt de 'o' kort (zoals in 'botten'). Bij 'boten' klinkt de 'o' lang → bo-ten. Onthoud: lange klank = open lettergreep.",
          "1": "Goed! 'bo-ten' — open lettergreep, lange 'o'.",
          "2": "Je dacht waarschijnlijk dat je twee o's schrijft. Maar in een open lettergreep (bo-ten) is de klank al lang — je hoeft geen extra 'o' toe te voegen. Onthoud: open lettergreep = één klinker.",
          "3": "Je dacht waarschijnlijk dat je twee t's schrijft. Maar 'bo-tten' bestaat niet. Dubbele medeklinker hoort bij een korte klinker (bakker-regel). Bij 'boten' is de 'o' lang → één 't'. Onthoud: lange klank = enkele medeklinker."
        }
      }
    },
    {
      "id": "SPR-KLANK-JAGER-004",
      "familyId": "SPR-KLANK-JAGER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_open_lange",
      "questionType": "multiple_choice",
      "question": "Het regent buiten. Welke spelling van 'regen' is juist?",
      "options": ["reggen", "reegen", "regn", "regen"],
      "correctAnswer": 3,
      "stimulusAids": [
        { "type": "syllableBlocks", "data": { "word": "regen", "syllables": ["re", "gen"], "types": ["open", "closed"], "label": "Lettergreepverdeling: re-gen" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Jager-regel: regen", "content": "Verdeel: re-gen. De eerste lettergreep 're' is open (eindigt op een klinker). De 'e' klinkt lang → schrijf één 'e' en één 'g'.", "icon": "lightbulb" } }
      ],
      "conceptId": "open_syllable_regen",
      "variantIndex": 4,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Regen' verdeel je als re-gen. De eerste lettergreep 're' is open — de 'e' klinkt lang. Bij een open lettergreep schrijf je maar één klinker en één medeklinker.",
        "solutionSteps": [
          "Verdeel in lettergrepen: re-gen",
          "'re' eindigt op een klinker → open lettergreep",
          "Lange klank → één 'e' en één 'g'"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je twee g's schrijft. Maar 'reggen' zou een korte 'e' geven (zoals in 'leggen'). Bij 'regen' klinkt de 'e' lang → één 'g'. Onthoud: lange klank = enkele medeklinker.",
          "1": "Je dacht waarschijnlijk dat je twee e's schrijft. Maar in een open lettergreep (re-gen) is de klank al lang. Onthoud: open lettergreep = één klinker.",
          "2": "Je dacht waarschijnlijk dat je de 'e' weglaat. Maar 'regn' is geen bestaand woord. Het is 're-gen' met twee lettergrepen. Onthoud: elke lettergreep heeft een klinker.",
          "3": "Goed! 'regen' — open lettergreep, dus één 'e' en één 'g'."
        }
      }
    },
    {
      "id": "SPR-KLANK-JAGER-005",
      "familyId": "SPR-KLANK-JAGER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_open_lange",
      "questionType": "multiple_choice",
      "question": "Welk woord past bij de jager-regel (open lettergreep, lange klank)?",
      "options": ["weven", "bakker", "rennen", "zitten"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Jager-regel herkennen", "content": "De jager-regel: open lettergreep → lange klank → enkele medeklinker. 'we-ven' heeft een open eerste lettergreep ('we'). De andere woorden hebben een gesloten eerste lettergreep met korte klinker (bakker-regel).", "icon": "lightbulb" } },
        { "type": "syllableBlocks", "showWhen": "wrong", "data": { "word": "weven", "syllables": ["we", "ven"], "types": ["open", "closed"], "label": "Lettergreepverdeling: we-ven — open eerste lettergreep" } }
      ],
      "conceptId": "open_syllable_recognition",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "'Weven' past bij de jager-regel. Verdeel: we-ven. De eerste lettergreep 'we' is open — de 'e' klinkt lang. De andere woorden (bakker, rennen, zitten) hebben een gesloten eerste lettergreep met korte klinker → bakker-regel.",
        "solutionSteps": [
          "Verdeel elk woord: we-ven, bak-ker, ren-nen, zit-ten",
          "'we-ven': open lettergreep → jager-regel ✓",
          "De andere drie: gesloten lettergreep → bakker-regel"
        ],
        "distractorExplanations": {
          "0": "Goed! 'we-ven' heeft een open eerste lettergreep → jager-regel.",
          "1": "Je dacht waarschijnlijk dat 'bakker' bij de jager-regel hoort. Maar 'bak-ker' heeft een gesloten eerste lettergreep met korte 'a' → bakker-regel (dubbele medeklinker). Onthoud: korte klank = bakker-regel.",
          "2": "Je dacht waarschijnlijk dat 'rennen' bij de jager-regel hoort. Maar 'ren-nen' heeft een gesloten eerste lettergreep met korte 'e' → bakker-regel. Onthoud: dubbele medeklinker = korte klank = bakker-regel.",
          "3": "Je dacht waarschijnlijk dat 'zitten' bij de jager-regel hoort. Maar 'zit-ten' heeft een gesloten eerste lettergreep met korte 'i' → bakker-regel. Onthoud: dubbele medeklinker = korte klank = bakker-regel."
        }
      }
    },
    {
      "id": "SPR-KLANK-JAGER-009",
      "familyId": "SPR-KLANK-JAGER",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_open_lange",
      "questionType": "categorize",
      "question": "Sorteer de woorden bij de juiste regel.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Jager-regel (lange klank)", "Bakker-regel (korte klank)"],
        "items": [
          { "text": "bomen", "correctCategory": 0 },
          { "text": "bommen", "correctCategory": 1 },
          { "text": "slapen", "correctCategory": 0 },
          { "text": "slappen", "correctCategory": 1 },
          { "text": "muren", "correctCategory": 0 },
          { "text": "mussen", "correctCategory": 1 }
        ]
      },
      "conceptId": "jager_bakker_categorize",
      "variantIndex": 9,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Hoor je een lange klank aan het eind van een klankgroep (bo-men, sla-pen, mu-ren)? Dan schrijf je één medeklinker (jager-regel). Hoor je een korte klank (bom-men, slap-pen, mus-sen)? Dan schrijf je twee medeklinkers (bakker-regel).",
        "solutionSteps": [
          "Verdeel het woord in klankgroepen",
          "Lange klank (a, e, o, u) → jager-regel (1 medeklinker)",
          "Korte klank (a, e, i, o, u) → bakker-regel (2 medeklinkers)"
        ]
      }
    }
  ]
}